import {React, useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { setDemoGraphyData } from '../../redux/actions/userActions';


const PatEmergencyContact = () => {


     const userData = useSelector((state) => state.user.user);
     const DemoGraphyData = useSelector((state) => state.user.demoDetails);

     
          
          const dispatch = useDispatch();
        
          const { id } = useParams();
          const PatientID = localStorage.setItem("PatientID", id);
          var userPracticeID = userData ? userData.practiceID : null;
        
          var userId = userData ? userData.userID : null;
        
          const sAuthToken = useSelector((state) => state.user.token);


          
              useEffect(() => {
                  const savedDemo = localStorage.getItem("demoData");
                  if (savedDemo) {
                      try {
                          const parsed = JSON.parse(savedDemo);
                          dispatch(setDemoGraphyData(parsed));
                      } catch (error) {
                          console.error("Error parsing demoData from localStorage:", error);
                          localStorage.removeItem("demoData");
          
          
                      }
                  }
              }, [dispatch]);
    
    
  return (
    <div>
      
    </div>
  )
}

export default PatEmergencyContact
